import { createProvider } from '@nvision/services/data-provider';

import { logger } from '../../utils/logger';
import * as api from './api';

export const deletePricing = createProvider((keys: string[], options: { signal?: AbortController['signal'] } = {}) =>
  Promise.all(keys.map((key) => api.deletePricing(key, options))),
)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Delete pricing is aborted');
    } else {
      logger.error(`Delete pricing was failed: ${error}`);
    }
    throw error;
  });
